import { Provider } from '@angular/core';
import { AudioCaptureService } from './audio-capture.service';
import { SpeechToTextAzureApiKeyService } from './azure/speech-to-text-azure-api-key.service';
import { SpeechToTextAzureService } from './azure/speech-to-text-azure.service';
import { SpeechToTextDeepgramService } from './deepgram/speech-to-text-deepgram.service';
import { MicrophoneAccessService } from './microphone-access.service';

export function provideSpeechToText(): Provider[] {
  return [
    { provide: AudioCaptureService, useClass: AudioCaptureService },
    {
      provide: MicrophoneAccessService,
      useClass: MicrophoneAccessService,
    },
    { provide: SpeechToTextAzureService, useClass: SpeechToTextAzureService },
    {
      provide: SpeechToTextAzureApiKeyService,
      useClass: SpeechToTextAzureApiKeyService,
    },
    {
      provide: SpeechToTextDeepgramService,
      useClass: SpeechToTextDeepgramService,
    },
  ];
}
